import React from "react";
import SvgSprite from "championship/src/components/Utils/SvgSprite";

class TextField extends React.Component{
    render(){
        const that = this
        return (
            <div>
                <div class="js-form-field__wrapper">
                    <div class="js-form-field__text">
                        <input type="text"/>
                        <input type="hidden"/>
                        <input 
                            type="time" 
                            name={this.props.name}
                            id={this.props.id}

                            // defaultValue={this.props.value}
                            required={this.props.required}
                            />
                    </div>
                    <div class="js-form-field__icon">
                        <SvgSprite id="clock" section="form"/>
                    </div>
                </div>
                <div class="form-field-popup picker-popup">
                    <div class="base-picker -sep-hours -highlight-onhover picker-wrapper"></div>
                    <div class="form-field-popup__buttons">
                        <div class="button -link -save">Сохранить</div>
                    </div>
                </div>
            </div>
        )
    }
}

export default TextField